export default __webpack_public_path__ + "static/media/tinder-app.4a1b7c1b.jpg";